// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 3840px) {

    .desktop-nav{
        display: flex;
        position: absolute;
        right: 125px;
        justify-content: center;
        align-items: center;
        margin-left: 50px;
    }

    .desktop-nav-link{
        margin: 0px 20px 0px 20px;
        font-size: 20px;
        font-weight: bold;
        cursor: pointer;
    }
        
    .header-with-menu{
        z-index: 1000;
        position:fixed;
        left: 0px;
    }
    
    .nav-container{
        position:fixed;
        width: 100%;
        height: 70px;
    }
    
    .navbar {
        background-color: #FFBD59;
        display:flex;
        height: 100%;
        align-items: center;
        position: sticky; /* Use fixed to make the navbar follow when scrolling */
        z-index: 1000; /* Ensure it stays above other content */
        color: #022452;
        border-bottom: var(--nav-border-bottom);
        border-bottom-right-radius: var(--nav-right-radius);
        border-bottom-left-radius: var(--nav-left-radius);
        box-shadow: var(--nav-box-shadow);
        justify-content: flex-start !important;
    }

    .nav-profile-logo{
        height: 100%;
        margin-left: 10px;
    }

    .profile-logo{
        font-size: 40px;
    }

    .header-logo-flex{
        display:flex;
        align-items: center;
        height: 100%;
        margin-left: 50px;
        cursor: pointer;
    }
    
    .menu-icon {
        font-size: 28px;
        color: #fff;
        padding: 0 15px;
        cursor: pointer;
    }
    
    .header-text {
        color: #fff;
        font-size: 18px;
    }

    .header-logo-flex h1{
        margin-top: auto;
        margin-bottom: auto;
    }
    
    .nav-login-button{
        font-family: "Kanit", sans-serif !important;
        width: 95px;
        height: 33px;
        color: #FFBD59;
        background: #022452;
        border: none;
        border-radius: 5px;
        font-weight: 500;
        font-size: 16px;
        box-shadow: 0px 0px 2px black;
        margin-right: 10px;
        position: absolute;
        right: 20px;
    }

    .nav-logout-button{
        font-family: "Kanit", sans-serif !important;
        width: 40px;
        height: 40px;
        color: #FFBD59;
        background: #022452;
        border: none;
        border-radius: 10px;
        font-weight: 500;
        font-size: 16px;
        box-shadow: 0px 0px 2px black;
        margin-right: 10px;
        display:flex;
        align-items: center;
        justify-content: center;
    }

    .nav-logout-button img{
        height: 80%;
    }

    .header-logo{
        height: 100%;
    }

    .nav-language-dropdown img{
        margin-left: 30px;
        display: flex;
        position: relative;
    }

    .custom-dropdown {
        position: relative;
        display: inline-block;
    }
    
    .dropdown-selected {
        cursor: pointer;
        display: flex;
        align-items: center;
    }
    
    .language-icon {
        width: 48px;
        height: 48px;
    }
    
    .custom-dropdown {
        position: absolute;
        top: 0%;
        left: 0%;
        width: 50px;
        height: 50px;
        z-index: 10000;
    }
    
    .custom-dropdown li {
        margin-top: 11px;
        cursor: pointer;
        display: flex;
        align-items: center;
    }
    
    .header-logout-button{
        width: 40px;
        height: 40px;
    }

    .header-logout-section{
        display: flex;
        position:absolute;
        align-items: center;
        right: 0px;
    }

    .header-profile-button{
        display: block;
        height: 50px;
        width: 50px;
        margin-right: 10px;
        cursor: pointer;
    }
}

@media screen and (max-width: 1250px){
    .desktop-nav{
        display: none;
    }
}

@media screen and (max-width: 540px) {

    .header-with-menu{
        z-index: 1000;
        position:fixed;
        left: 0px;
    }
    
    .nav-container{
        position:fixed;
        width: 100%;
        height: 70px;
    }
    
    .navbar {
        background-color: #FFBD59;
        display:flex;
        height: 100%;
        align-items: center;
        justify-content: center;
        position: sticky; /* Use fixed to make the navbar follow when scrolling */
        z-index: 1000; /* Ensure it stays above other content */
        color: #022452;
        border-bottom: var(--nav-border-bottom);
        border-bottom-right-radius: var(--nav-right-radius);
        border-bottom-left-radius: var(--nav-left-radius);
        box-shadow: var(--nav-box-shadow);
    }

    .nav-profile-logo{
        height: 100%;
        margin-left: 10px;
    }

    .profile-logo{
        font-size: 40px;
    }

    .header-logo-flex{
        display:flex;
        align-items: center;
        height: 100%;
        margin: 0px;
    }
    
    .menu-icon {
        font-size: 28px;
        color: #fff;
        padding: 0 15px;
        cursor: pointer;
    }
    
    .header-text {
        color: #fff;
        font-size: 18px;
    }

    .header-logo-flex h1{
        margin-top: auto;
        margin-bottom: auto;
    }
    
    .nav-login-button{
        font-family: "Kanit", sans-serif !important;
        width: 70px;
        height: 33px;
        color: #FFBD59;
        background: #022452;
        border: none;
        border-radius: 5px;
        font-weight: 500;
        font-size: 16px;
        box-shadow: 0px 0px 2px black;
        margin-right: 0px;
    }

    .nav-logout-button{
        font-family: "Kanit", sans-serif !important;
        width: 40px;
        height: 40px;
        color: #FFBD59;
        background: #022452;
        border: none;
        border-radius: 10px;
        font-weight: 500;
        font-size: 16px;
        box-shadow: 0px 0px 2px black;
        margin-right: 10px;
        display:flex;
        align-items: center;
        justify-content: center;
    }

    .nav-logout-button img{
        height: 80%;
    }

    .header-logo{
        height: 100%;
    }

    .nav-language-dropdown img{
        margin-left: 10px;
        margin-right: 10px;
        display: flex;
        position: relative;
    }

    .custom-dropdown {
        position: relative;
        display: inline-block;
    }
    
    .dropdown-selected {
        cursor: pointer;
        display: flex;
        align-items: center;
    }
    
    .language-icon {
        width: 40px;
        height: 40px;
    }
    
    .custom-dropdown {
        position: absolute;
        top: 0%;
        left: 0%;
        width: 50px;
        height: 50px;
        z-index: 10000;
    }
    
    .custom-dropdown li {
        margin-top: 11px;
        cursor: pointer;
        display: flex;
        align-items: center;
    }
    
    .header-logout-button{
        width: 40px;
        height: 40px;
    }

    .header-profile-button{
        display: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/layouts/Header.css"],"names":[],"mappings":"AAAA;;IAEI;QACI,aAAa;QACb,kBAAkB;QAClB,YAAY;QACZ,uBAAuB;QACvB,mBAAmB;QACnB,iBAAiB;IACrB;;IAEA;QACI,yBAAyB;QACzB,eAAe;QACf,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,cAAc;QACd,SAAS;IACb;;IAEA;QACI,cAAc;QACd,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,yBAAyB;QACzB,YAAY;QACZ,YAAY;QACZ,mBAAmB;QACnB,gBAAgB,EAAE,uDAAuD;QACzE,aAAa,EAAE,wCAAwC;QACvD,cAAc;QACd,uCAAuC;QACvC,mDAAmD;QACnD,iDAAiD;QACjD,iCAAiC;QACjC,sCAAsC;IAC1C;;IAEA;QACI,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,mBAAmB;QACnB,YAAY;QACZ,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,WAAW;QACX,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,2CAA2C;QAC3C,WAAW;QACX,YAAY;QACZ,cAAc;QACd,mBAAmB;QACnB,YAAY;QACZ,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;QACf,6BAA6B;QAC7B,kBAAkB;QAClB,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,2CAA2C;QAC3C,WAAW;QACX,YAAY;QACZ,cAAc;QACd,mBAAmB;QACnB,YAAY;QACZ,mBAAmB;QACnB,gBAAgB;QAChB,eAAe;QACf,6BAA6B;QAC7B,kBAAkB;QAClB,YAAY;QACZ,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,qBAAqB;IACzB;;IAEA;QACI,eAAe;QACf,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,OAAO;QACP,QAAQ;QACR,WAAW;QACX,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,iBAAiB;QACjB,mBAAmB;QACnB,UAAU;IACd;;IAEA;QACI,cAAc;QACd,YAAY;QACZ,WAAW;QACX,kBAAkB;QAClB,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;;IAEI;QACI,aAAa;QACb,cAAc;QACd,SAAS;IACb;;IAEA;QACI,cAAc;QACd,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,yBAAyB;QACzB,YAAY;QACZ,YAAY;QACZ,mBAAmB;QACnB,uBAAuB;QACvB,gBAAgB,EAAE,uDAAuD;QACzE,aAAa,EAAE,wCAAwC;QACvD,cAAc;QACd,uCAAuC;QACvC,mDAAmD;QACnD,iDAAiD;QACjD,iCAAiC;IACrC;;IAEA;QACI,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,mBAAmB;QACnB,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,eAAe;QACf,WAAW;QACX,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,2CAA2C;QAC3C,WAAW;QACX,YAAY;QACZ,cAAc;QACd,mBAAmB;QACnB,YAAY;QACZ,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;QACf,6BAA6B;QAC7B,iBAAiB;IACrB;;IAEA;QACI,2CAA2C;QAC3C,WAAW;QACX,YAAY;QACZ,cAAc;QACd,mBAAmB;QACnB,YAAY;QACZ,mBAAmB;QACnB,gBAAgB;QAChB,eAAe;QACf,6BAA6B;QAC7B,kBAAkB;QAClB,YAAY;QACZ,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,qBAAqB;IACzB;;IAEA;QACI,eAAe;QACf,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,OAAO;QACP,QAAQ;QACR,WAAW;QACX,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":["@media screen and (max-width: 3840px) {\n\n    .desktop-nav{\n        display: flex;\n        position: absolute;\n        right: 125px;\n        justify-content: center;\n        align-items: center;\n        margin-left: 50px;\n    }\n\n    .desktop-nav-link{\n        margin: 0px 20px 0px 20px;\n        font-size: 20px;\n        font-weight: bold;\n        cursor: pointer;\n    }\n        \n    .header-with-menu{\n        z-index: 1000;\n        position:fixed;\n        left: 0px;\n    }\n    \n    .nav-container{\n        position:fixed;\n        width: 100%;\n        height: 70px;\n    }\n    \n    .navbar {\n        background-color: #FFBD59;\n        display:flex;\n        height: 100%;\n        align-items: center;\n        position: sticky; /* Use fixed to make the navbar follow when scrolling */\n        z-index: 1000; /* Ensure it stays above other content */\n        color: #022452;\n        border-bottom: var(--nav-border-bottom);\n        border-bottom-right-radius: var(--nav-right-radius);\n        border-bottom-left-radius: var(--nav-left-radius);\n        box-shadow: var(--nav-box-shadow);\n        justify-content: flex-start !important;\n    }\n\n    .nav-profile-logo{\n        height: 100%;\n        margin-left: 10px;\n    }\n\n    .profile-logo{\n        font-size: 40px;\n    }\n\n    .header-logo-flex{\n        display:flex;\n        align-items: center;\n        height: 100%;\n        margin-left: 50px;\n        cursor: pointer;\n    }\n    \n    .menu-icon {\n        font-size: 28px;\n        color: #fff;\n        padding: 0 15px;\n        cursor: pointer;\n    }\n    \n    .header-text {\n        color: #fff;\n        font-size: 18px;\n    }\n\n    .header-logo-flex h1{\n        margin-top: auto;\n        margin-bottom: auto;\n    }\n    \n    .nav-login-button{\n        font-family: \"Kanit\", sans-serif !important;\n        width: 95px;\n        height: 33px;\n        color: #FFBD59;\n        background: #022452;\n        border: none;\n        border-radius: 5px;\n        font-weight: 500;\n        font-size: 16px;\n        box-shadow: 0px 0px 2px black;\n        margin-right: 10px;\n        position: absolute;\n        right: 20px;\n    }\n\n    .nav-logout-button{\n        font-family: \"Kanit\", sans-serif !important;\n        width: 40px;\n        height: 40px;\n        color: #FFBD59;\n        background: #022452;\n        border: none;\n        border-radius: 10px;\n        font-weight: 500;\n        font-size: 16px;\n        box-shadow: 0px 0px 2px black;\n        margin-right: 10px;\n        display:flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    .nav-logout-button img{\n        height: 80%;\n    }\n\n    .header-logo{\n        height: 100%;\n    }\n\n    .nav-language-dropdown img{\n        margin-left: 30px;\n        display: flex;\n        position: relative;\n    }\n\n    .custom-dropdown {\n        position: relative;\n        display: inline-block;\n    }\n    \n    .dropdown-selected {\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n    }\n    \n    .language-icon {\n        width: 48px;\n        height: 48px;\n    }\n    \n    .custom-dropdown {\n        position: absolute;\n        top: 0%;\n        left: 0%;\n        width: 50px;\n        height: 50px;\n        z-index: 10000;\n    }\n    \n    .custom-dropdown li {\n        margin-top: 11px;\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n    }\n    \n    .header-logout-button{\n        width: 40px;\n        height: 40px;\n    }\n\n    .header-logout-section{\n        display: flex;\n        position:absolute;\n        align-items: center;\n        right: 0px;\n    }\n\n    .header-profile-button{\n        display: block;\n        height: 50px;\n        width: 50px;\n        margin-right: 10px;\n        cursor: pointer;\n    }\n}\n\n@media screen and (max-width: 1250px){\n    .desktop-nav{\n        display: none;\n    }\n}\n\n@media screen and (max-width: 540px) {\n\n    .header-with-menu{\n        z-index: 1000;\n        position:fixed;\n        left: 0px;\n    }\n    \n    .nav-container{\n        position:fixed;\n        width: 100%;\n        height: 70px;\n    }\n    \n    .navbar {\n        background-color: #FFBD59;\n        display:flex;\n        height: 100%;\n        align-items: center;\n        justify-content: center;\n        position: sticky; /* Use fixed to make the navbar follow when scrolling */\n        z-index: 1000; /* Ensure it stays above other content */\n        color: #022452;\n        border-bottom: var(--nav-border-bottom);\n        border-bottom-right-radius: var(--nav-right-radius);\n        border-bottom-left-radius: var(--nav-left-radius);\n        box-shadow: var(--nav-box-shadow);\n    }\n\n    .nav-profile-logo{\n        height: 100%;\n        margin-left: 10px;\n    }\n\n    .profile-logo{\n        font-size: 40px;\n    }\n\n    .header-logo-flex{\n        display:flex;\n        align-items: center;\n        height: 100%;\n        margin: 0px;\n    }\n    \n    .menu-icon {\n        font-size: 28px;\n        color: #fff;\n        padding: 0 15px;\n        cursor: pointer;\n    }\n    \n    .header-text {\n        color: #fff;\n        font-size: 18px;\n    }\n\n    .header-logo-flex h1{\n        margin-top: auto;\n        margin-bottom: auto;\n    }\n    \n    .nav-login-button{\n        font-family: \"Kanit\", sans-serif !important;\n        width: 70px;\n        height: 33px;\n        color: #FFBD59;\n        background: #022452;\n        border: none;\n        border-radius: 5px;\n        font-weight: 500;\n        font-size: 16px;\n        box-shadow: 0px 0px 2px black;\n        margin-right: 0px;\n    }\n\n    .nav-logout-button{\n        font-family: \"Kanit\", sans-serif !important;\n        width: 40px;\n        height: 40px;\n        color: #FFBD59;\n        background: #022452;\n        border: none;\n        border-radius: 10px;\n        font-weight: 500;\n        font-size: 16px;\n        box-shadow: 0px 0px 2px black;\n        margin-right: 10px;\n        display:flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    .nav-logout-button img{\n        height: 80%;\n    }\n\n    .header-logo{\n        height: 100%;\n    }\n\n    .nav-language-dropdown img{\n        margin-left: 10px;\n        margin-right: 10px;\n        display: flex;\n        position: relative;\n    }\n\n    .custom-dropdown {\n        position: relative;\n        display: inline-block;\n    }\n    \n    .dropdown-selected {\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n    }\n    \n    .language-icon {\n        width: 40px;\n        height: 40px;\n    }\n    \n    .custom-dropdown {\n        position: absolute;\n        top: 0%;\n        left: 0%;\n        width: 50px;\n        height: 50px;\n        z-index: 10000;\n    }\n    \n    .custom-dropdown li {\n        margin-top: 11px;\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n    }\n    \n    .header-logout-button{\n        width: 40px;\n        height: 40px;\n    }\n\n    .header-profile-button{\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
